import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
var kTimeAggregationDefault = {
  timeZone: 'Europe/Berlin',
  firstWeekDay: 'Monday'
};
export default {
  name: 'CoreDtwinStateTimeseriesAggregateEdit',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    otherStates: {
      type: Array,
      required: true
    },
    tenantId: {
      type: Number,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      timeAggregation: cloneDeep(kTimeAggregationDefault),
      offset: null,
      offsetUnit: null,
      periodLength: null,
      periodUnit: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    availableDurations: function availableDurations() {
      var _this = this;

      return [{
        value: 15 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.15m')
      }, {
        value: 30 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.30m')
      }, {
        value: 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.1h')
      }, {
        value: 3 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.3h')
      }, {
        value: 6 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.6h')
      }, {
        value: 12 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.12h')
      }, {
        value: 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.24h')
      }, {
        value: 2 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.2d'),
        forFixed: false
      }, {
        value: 7 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.7d')
      }, {
        value: 14 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.2w'),
        forFixed: false
      }, {
        value: 30 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.1M')
      }, {
        value: 90 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.3M')
      }, {
        value: 180 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.6M')
      }, {
        value: 365 * 24 * 60 * 60,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.timeRanges.1Y')
      }, {
        value: 'now/h',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.currentHour')
      }, {
        value: 'now-1h/h',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.periousHour'),
        forFixed: true
      }, {
        value: 'now/d',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.today')
      }, {
        value: 'now-1d/d',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.yesterday'),
        forFixed: true
      }, {
        value: 'now/w',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeek')
      }, {
        value: 'now/M',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonth')
      }, {
        value: 'now/y',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYear')
      }, {
        value: 'now-1w/w',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousWeek'),
        forFixed: true
      }, {
        value: 'now-1M/M',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousMonth'),
        forFixed: true
      }, {
        value: 'now-1y/y',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousYear'),
        forFixed: true
      }, {
        value: 'now-2d/d',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.dayBeforeYesterday'),
        forFixed: true
      }, {
        value: 'now-7d/d',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisDayLastWeek'),
        forFixed: true
      }].filter(function (d) {
        return !_this.timeAggregation.fixedTimestamp || typeof d.value !== 'number' && d.forFixed === true;
      });
    },
    availableOperators: function availableOperators() {
      return [{
        value: 'avg',
        text: 'AVG'
      }, {
        value: 'min',
        text: 'MIN'
      }, {
        value: 'max',
        text: 'MAX'
      }, {
        value: 'sum',
        text: 'SUM'
      }, {
        value: 'median',
        text: 'MEDIAN'
      }, {
        value: 'count',
        text: 'COUNT'
      }, {
        value: 'diff',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.difference'),
        desc: this.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.differenceText')
      }, {
        value: 'latest_diff',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.lastDifference'),
        desc: this.$i18n_t('DigitalTwin.DigitalTwin.states.timeseries-aggregate.lastDifferenceText')
      }];
    },
    timeUnits: function timeUnits() {
      return [{
        value: 'm',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.units.minutes')
      }, {
        value: 'h',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.units.hours')
      }, {
        value: 'd',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.units.days')
      }, {
        value: 'w',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.units.weeks')
      }, {
        value: 'M',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.units.months')
      }, {
        value: 'y',
        text: this.$i18n_t('Core.DateTimePicker.rangeItems.units.years')
      }];
    },
    requiredRule: function requiredRule() {
      var _this2 = this;

      return [function (v) {
        return !!v || parseInt(v) === 0 || _this2.$i18n_t('Common.fieldRequired');
      }];
    },
    hourRules: function hourRules() {
      var _this3 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v >= 0 && v <= 23 || _this3.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourRule');
      }]);
    },
    minuteRules: function minuteRules() {
      var _this4 = this;

      return [].concat(_toConsumableArray(this.requiredRule), [function (v) {
        return v >= 0 && v <= 59 || _this4.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.minuteRule');
      }]);
    }
  }),
  watch: {
    lclModel: function lclModel() {
      this.timeAggregation = this.lclModel.properties.binding.options.timeAggregation || cloneDeep(kTimeAggregationDefault);
      this.calcMomentStringComponents();
    },
    'timeAggregation.stateId': function timeAggregationStateId() {
      var _this5 = this;

      this.lclModel.properties.binding.options.timeAggregation.stateId = this.timeAggregation.stateId;
      var state = this.otherStates.find(function (s) {
        return s.id === _this5.timeAggregation.stateId;
      });

      if (!this.lclModel.properties.faIcon) {
        this.lclModel.properties.faIcon = state.properties.faIcon;
      }

      if (!this.lclModel.properties.unit) {
        this.lclModel.properties.unit = state.properties.unit;
      }

      this.lclModel.properties = cloneDeep(this.lclModel.properties);
    },
    'timeAggregation.duration': function timeAggregationDuration() {
      this.lclModel.properties.binding.options.timeAggregation.duration = this.timeAggregation.duration;
    },
    'timeAggregation.fixedTimestamp': function timeAggregationFixedTimestamp() {
      var _this6 = this;

      this.lclModel.properties.binding.options.timeAggregation.fixedTimestamp = this.timeAggregation.fixedTimestamp;

      if (this.timeAggregation.fixedTimestamp) {
        // default time-range to one of the fixed durations
        if (this.availableDurations.findIndex(function (d) {
          return d.value === _this6.timeAggregation.duration;
        }) < 0) {
          this.timeAggregation.duration = this.availableDurations[0].value;
        }
      }

      this.lclModel.properties.binding.options.timeAggregation.duration = this.timeAggregation.duration;
    },
    'timeAggregation.operator': function timeAggregationOperator() {
      this.lclModel.properties.binding.options.timeAggregation.operator = this.timeAggregation.operator;
    },
    'timeAggregation.timeZone': function timeAggregationTimeZone() {
      this.lclModel.properties.binding.options.timeAggregation.timeZone = this.timeAggregation.timeZone;
    },
    'timeAggregation.firstWeekDay': function timeAggregationFirstWeekDay() {
      this.lclModel.properties.binding.options.timeAggregation.firstWeekDay = this.timeAggregation.firstWeekDay;
    }
  },
  mounted: function mounted() {
    this.lclModel.properties.binding.options = _objectSpread(_objectSpread({}, this.lclModel.properties.binding.options), {}, {
      timeAggregation: _objectSpread({}, this.lclModel.properties.binding.options.timeAggregation || cloneDeep(kTimeAggregationDefault))
    });
    this.timeAggregation = this.lclModel.properties.binding.options.timeAggregation;
    this.timeAggregation.key = this.lclModel.key;
    this.calcMomentStringComponents();
  },
  methods: {
    calcMomentStringComponents: function calcMomentStringComponents() {
      if (isNaN(parseInt(this.timeAggregation.duration))) {
        var matches = ((this.timeAggregation.duration || '').match(/^(now)(?:([-+]{1})([0-9]+)([mhdwMy]))?(?:\/([0-9]*)([hdwMy]+))?$/) || []).slice(2);
        this.offset = (get(matches, '[0]') === '-' ? 1 : -1) * parseInt(get(matches, '[1]'), 10) || 0;
        this.offsetUnit = get(matches, '[2]') || get(matches, '[4]') || 'm';
        this.periodLength = get(matches, '[3]') || 1;
        this.periodUnit = get(matches, '[4]') || 'm';
      } else {
        var unitMapping = [{
          length: 60,
          unit: 'm'
        }, {
          length: 3600,
          unit: 'h'
        }, {
          length: 86400,
          unit: 'd'
        }, {
          length: 86400 * 7,
          unit: 'w'
        }, {
          length: 86400 * 30,
          unit: 'M'
        }, {
          length: 86400 * 365,
          unit: 'y'
        }];
        var i = 1;

        while (i < unitMapping.length) {
          var currentMapping = unitMapping[i];

          if (Math.floor(this.timeAggregation.duration / currentMapping.length) < 1) {
            i--;
            break;
          }

          i++;
        } // Start Insert MWa stabilization Release 21.12.2021


        if (i === unitMapping.length) {
          i = unitMapping.length - 1;
        } // End Insert MWa stabilization Release 21.12.2021


        this.offset = 0;
        this.offsetUnit = unitMapping[i].unit;
        this.periodLength = Math.floor(this.timeAggregation.duration / unitMapping[i].length);
        this.periodUnit = unitMapping[i].unit;
      }
    },
    calcMomentString: function calcMomentString() {
      this.timeAggregation.duration = "now-".concat(this.offset).concat(this.offsetUnit, "/").concat(this.periodLength).concat(this.periodUnit);
      this.timeAggregation = cloneDeep(this.timeAggregation);
    }
  }
};